import type { LocationQuery } from 'vue-router'
import { useConstants } from '~/utils/constants'

const { QUERY_PARAMS } = useConstants()
const SUPPLIER_QUERY_KEY = QUERY_PARAMS.suppliers

function toStringArray(value: unknown): string[] {
  if (!value) return []
  return (Array.isArray(value) ? value : [value])
    .filter((entry): entry is string => typeof entry === 'string' && entry.length > 0)
}

export function sameSupplierHandles(left: readonly string[], right: readonly string[]): boolean {
  return left.length === right.length && left.every((value, index) => value === right[index])
}

export function supplierHandlesFromQuery(query: LocationQuery): string[] {
  return toStringArray(query[SUPPLIER_QUERY_KEY])
}

export function orderHistorySuppliersFromRoute(path: string, query: LocationQuery): string[] {
  if (!path.split('/').includes('order-history')) return []
  return supplierHandlesFromQuery(query)
}

/**
 * Campaign / last-order supplier filter in the URL (`?s=`).
 * Unknown query keys are ignored; writes rebuild the query from `s` only.
 */
export function useSupplierFilterQuery() {
  const route = useRoute()

  const supplierHandles = computed(() => supplierHandlesFromQuery(route.query))

  function setSupplierHandles(handles: readonly string[]): void {
    const next = [...new Set(toStringArray(handles))]
    if (sameSupplierHandles(supplierHandles.value, next)) return
    navigateTo({
      query: next.length > 0 ? { [SUPPLIER_QUERY_KEY]: next } : {},
    })
  }

  return {
    supplierHandles,
    setSupplierHandles,
  }
}
